import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface ClearPhoneVerificationForAllConcernResponse extends BackendResponse {}
export interface ClearPhoneVerificationForAllConcernParameters extends NextApiParams {}

export const clearPhoneVerificationForAllConcern = withNextApi<
  ClearPhoneVerificationForAllConcernResponse,
  ClearPhoneVerificationForAllConcernParameters
>("/cvp/CvpClearPhoneVerificationForAllConcern");
